module.exports = __webpack_public_path__ + "static/media/OpenFace.852d9bce.png";